import { AfterViewInit, Component, Input } from '@angular/core';
import { User } from 'angular-lib';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'ez-user-picture',
    template: require('./user-picture.component.html'),
    styles: [require('./user-picture.component.less')]
})

export class UserPictureComponent implements AfterViewInit {
    private _user: User;
    private _viewInited: boolean = false;
    public src: string;

    @Input() public background: boolean = false;
    @Input() set user(user: User) {
        this._user = user;
        if (this._viewInited) {
            this.setDefaultPicture();
        }
    }

    public ngAfterViewInit() {
        this._viewInited = true;
        if (this._user) {
            setTimeout(() => {
                this.setDefaultPicture();
            });
        }
    }

    public setDefaultPicture () {
        let picture = this._user.getDefaultPicture();
        if (picture !== null) {
            this.src = this._user.getPictureUrl(picture, this._user.channelId, environment.scheme, environment.statichost, false, 120);
        }

        if (this.src === '' || typeof this.src === 'undefined') {
            let defaultPicture = this._user.genderId === 1 ? 'woman' : 'man';
            this.src = '/img/' + defaultPicture + '.jpg';
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/user-picture/user-picture.component.ts